import Vue from 'vue';
import Alert from '@/utils/Alert';

Vue.prototype.$alert = new Alert();
